module.exports = "/images/scroll.svg?25a7d75faad96cd33550004d6b166a2b";